import { IconWrapper, ISvgIconProps } from '.';
export default IconWrapper('file-down', true, (props: ISvgIconProps) => (
  <svg width={props.size} height={props.size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.7,8h2L8,10.7L5.3,8h2V5.3h1.3V8z M10,2.7H3.3v10.7h9.3v-8H10V2.7z M2,2c0-0.4,0.3-0.7,0.7-0.7h8  L14,4.7V14c0,0.2-0.1,0.3-0.2,0.5s-0.3,0.2-0.5,0.2H2.7C2.3,14.7,2,14.4,2,14V2L2,2z"
      fill={props.colors[0]}
    />
  </svg>
));
